<template>
  <!--收到的签署-->
  <div class="sign-list">
    <navTab navTabArrType="mySignList" :navTabVal.sync="navTabVal" />
    <template v-if="navTabVal === 'corpMySign'">
      <el-row type="flex" class="row">
        <el-col :span="6"></el-col>
        <el-col :span="6">
          <el-row :gutter="10">
            <el-col :span="12">
              <el-select v-model="selectedParm" placeholder="请选择" size="small">
                <el-option label="文件名称" value="contractName" />
                <el-option label="签署方" value="signatoryFullName" />
              </el-select>
            </el-col>
            <el-col :span="12">
              <el-input v-model="selectedParmInfo" size="small" placeholder="查询内容" />
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="4">
          <div style="text-align: center; white-space: nowrap">
            <el-select style="width: 140px" v-model="selectedStatus" placeholder="请选择" size="small">
              <el-option
                v-for="(item, index) in statusEnum"
                :label="item.label"
                :key="'status' + index"
                :value="item.value"
              />
            </el-select>
          </div>
        </el-col>
        <el-col :span="5">
          <el-row>
            <el-date-picker
              v-model="datePikerArr"
              type="daterange"
              value-format="yyyy-MM-dd"
              :default-time="['00:00:00', '23:59:59']"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              size="small"
              style="width: 100%"
            />
          </el-row>
        </el-col>
        <el-col :span="3">
          <el-row type="flex">
            <el-col :span="12" class="text-right">
              <el-button @click="findScreenSign" size="small">查询</el-button>
            </el-col>
            <el-col :span="12" class="text-right">
              <el-button @click="rest" size="small">重置</el-button>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <div class="table-wrap">
        <el-table
          style="min-height: 54vh"
          class="data-list"
          :data="tableList"
          tooltip-effect="dark"
          ref="dataList"
          v-loading="loading"
          :key="'signlist-' + $route.query.signStatus"
          :expand-row-keys="expandKeys"
          :row-key="
          (row) => {
            return row.applyId;
          }
        "
          @selection-change="handleSelectionChange"
          @cell-mouse-enter="cellMouseEnter"
          @cell-mouse-leave="cellMouseLeave"
          :header-cell-style="{
          background: '#f9f9f9',
          color: '#333333',
          fontWeight: '500',
        }"
        >
          <el-table-column type="selection" width="55" />
          <el-table-column label="文件名称" min-width="300">
            <template slot-scope="scope">
              <div
                style="
                display: flex;
                align-items: center;
                position: relative;
                padding-top: 10px;
              "
              >
                <span class="multiFile" v-if="scope.row.files > 1">多</span>
                <apply-name
                  @handleInsurance="
                  handleInsurance({
                    insureState: scope.row.insureState,
                    preservationId: scope.row.preservationId,
                    signNo: scope.row.signInfoNo,
                  })
                "
                  applyType="signList"
                  :signInfo="{
                  status: scope.row.applySignStatus,
                  signNo: scope.row.signInfoNo,
                  applyNo: scope.row.applyNo,
                  name: scope.row.contractName,
                  row: scope.row,
                  selfSign: scope.row.selfSign,
                  insureState: scope.row.insureState,
                  preservationId: scope.row.preservationId,
                  multiFile: scope.row.multiFile,
                }"
                ></apply-name>
              </div>
              <p
                class="textEllipsis"
                v-if="[17,20,'17','20'].includes(scope.row.applySignDealType)"
              >
                批量签编号：
                <el-tooltip
                  effect="dark"
                  :content="scope.row.businessNo ? scope.row.businessNo : ''"
                  placement="bottom-start"
                >
                  <span>{{ scope.row.businessNo }}</span>
                </el-tooltip>
              </p>
              <p class="textEllipsis">
                发起方：
                <el-tooltip effect="dark" :content="scope.row.ebqUserName" placement="bottom-start">
                  <span>{{ scope.row.ebqUserName }}</span>
                </el-tooltip>
              </p>
              <p class="textEllipsis">
                发起时间：{{ scope.row.applyCreateTime | formatDateHM
                }}
                <img
                  src="/images/icon/dingIcon.png"
                  alt="钉钉"
                  width="20px"
                  style="margin-left: 10px"
                  v-if="scope.row.fromDingTalk && scope.row.fromDingTalk == 1 && !isInDingTalk"
                />
              </p>
            </template>
          </el-table-column>
          <el-table-column label="签署方" min-width="250">
            <template slot-scope="scope">
              <el-tooltip placement="bottom-start">
                <div
                  slot="content"
                  v-for="(item, inx) in scope.row.signInfoVOS"
                  style="display: flex; align-items: center; padding-bottom: 5px"
                  :key="`qs${inx}`"
                >
                  <span
                    v-if="item.orderNum && item.orderNum >= 1"
                    style="
                    display: block;
                    width: 13px;
                    height: 13px;
                    border-radius: 50%;
                    color: #ffffff;
                    border: 1px solid #ffffff;
                    text-align: center;
                    line-height: 13px;
                    font-size: 12px;
                  "
                  >{{ item.orderNum }}</span>
                  <span v-else style="color: #ffffff">·</span>
                  <div style="color: #ffffff; font-size: 12px">
                    【{{
                    item.signStatus === 0 || item.signStatus === -1
                    ? "未签署"
                    : item.signStatus === 1
                    ? "已签署"
                    : "已拒签"
                    }}】
                  </div>
                  <p style="color: #ffffff; font-size: 12px">{{ item.signatoryFullName }}</p>
                </div>
                <div>
                  <p class="textEllipsis">{{ scope.row.signInfoVOS[0].signatoryFullName }}</p>
                  <p
                    class="textEllipsis"
                    v-if="(scope.row.signInfoVOS.length > 1)"
                  >{{ scope.row.signInfoVOS[1].signatoryFullName }}</p>
                  <template>
                    <p
                      class="textEllipsis"
                      v-if="(scope.row.signInfoVOS.length === 3)"
                    >{{ scope.row.signInfoVOS[2].signatoryFullName }}</p>
                    <p class="textEllipsis" v-if="(scope.row.signInfoVOS.length > 3)">···</p>
                  </template>
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="状态" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.applySignStatus === -1" class="red">处理中</span>
              <template v-else-if="scope.row.applySignStatus === 0">
                <span v-if="scope.row.selfSign === 1" class="red">待我签</span>
                <span v-else class="blue">待ta签</span>
              </template>
              <span v-else-if="scope.row.applySignStatus === 1" class="green">已完成</span>
              <span v-else-if="scope.row.applySignStatus === 2" class="orange">已拒签</span>
              <span v-else-if="scope.row.applySignStatus === 4" class="orange">已作废</span>
              <span v-else-if="scope.row.applySignStatus === -5" class="grey">已撤销</span>
              <span v-else-if="scope.row.applySignStatus === -6" class="grey">已过期</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="130">
            <template slot-scope="scope" v-if="!(scope.row.applyNo && scope.row.applyNo.startsWith('APLO')) && scope.row.applySignStatus !== -1">
              <div class="operate-box">
                <apply-handles
                  v-if="
                  scope.row.applySignStatus !== 1 && scope.row.signStatus !== 1
                "
                  class="colum"
                  @handleInsurance="
                  handleInsurance({
                    insureState: scope.row.insureState,
                    preservationId: scope.row.preservationId,
                    signNo: scope.row.signInfoNo,
                  })
                "
                  :rowData="scope.row"
                  applyType="signList"
                  fieldType="applySignStatus"
                  @setCSDialogData="onSetCSDialogData"
                  @resetList="getSignLists"
                ></apply-handles>
                <!--    新按钮          -->
                <template
                  v-if="
                  scope.row.applySignStatus === 1 || scope.row.signStatus === 1
                "
                >
                  <existing-evidence :rowData="scope.row" @copyTextToQueryEmit="copyTextToQuery"></existing-evidence>
                  <el-dropdown
                    trigger="click"
                    @visible-change="visiChange($event, scope.row.applyId)"
                  >
                    <span class="com-normal-btn">
                      更多操作
                      <i
                        :class="
                        visiDown.status &&
                        visiDown.rowApplyId == scope.row.applyId
                          ? 'el-icon-caret-top'
                          : 'el-icon-caret-bottom'
                      "
                        class="com-normal-btn el-icon--right"
                      ></i>
                    </span>
                    <el-dropdown-menu slot="dropdown" style="background-color: #f5f6f6">
                      <more-button
                        :rowData="scope.row"
                        :Cancancel="isInDingTalk ? false : true"
                        :showcancelBtn="true"
                        @btnMethodFn="openLYDialog"
                        @handleInsurance="
                          handleInsurance({
                            insureState: scope.row.insureState,
                            preservationId: scope.row.preservationId,
                            signNo: scope.row.signInfoNo,
                          })
                        "
                      ></more-button>
                    </el-dropdown-menu>
                  </el-dropdown>
                </template>
                <span
                  class="com-normal-btn"
                  v-if="
                  scope.row.applySignStatus === 4 || scope.row.signStatus === 4
                "
                  @click="toApplyDetail(scope.row)"
                >查看作废协议</span>
              </div>
            </template>
          </el-table-column>
          <no-data text="暂无数据" slot="empty" />
        </el-table>
        <div class="bulkOperation" v-if="batchLength && false">
          已选{{ batchLength }}份文件
          <div :class="$route.query.match ? 'position1' : 'position2'" v-if="false">
            <template v-if="$route.query.directoryId">
              <!--占位，移除按钮在signInfo页面统一处理-->
              <el-tooltip effect="dark" v-if="+$route.query.signStatus !== 3">
                <p slot="content" style="width: 200px; line-height: 1.5">
                  批量签署规则：
                  <br />1、当前签署方必须有固定签章位置
                  <br />2、当前签署方不需要进行身份认证
                  <br />3、当前签署方不包含强制阅读、强制现场
                  <br />4、当前签署方不需要支付费用
                </p>
                <el-button @click="batchSign" size="small">批量签署</el-button>
              </el-tooltip>
              <el-button v-if="+$route.query.signStatus !== 2" @click="batchDown" size="small">下载</el-button>
            </template>
            <template v-else>
              <el-button @click="delSignTabList" size="mini">删除</el-button>
              <el-button v-if="+$route.query.signStatus !== 2" @click="batchDown" size="mini">下载</el-button>
              <el-tooltip effect="dark" v-if="+$route.query.signStatus !== 3">
                <p slot="content" style="width: 200px; line-height: 1.5">
                  批量签署规则：
                  <br />1、当前签署方必须有固定签章位置
                  <br />2、当前签署方不需要进行身份认证
                  <br />3、当前签署方不包含强制阅读、强制现场
                  <br />4、当前签署方不需要支付费用
                </p>
                <el-button @click="batchSign" size="mini">批量签署</el-button>
              </el-tooltip>
              <!-- 历史文件移动到 收件箱里面 -->
              <!-- <el-button v-if="$route.query.signStatus == 3" @click="toHistory" size="small">历史文件</el-button> -->
            </template>
          </div>
        </div>
      </div>
      <!--分页栏-->
      <el-row class="pageation row" :style="{ marginLeft: $route.query.match == -1 ? '70px' : 0 }">
        <el-col :span="7">
          <template v-if="$route.query.directoryId">
            <!--占位，移除按钮在signInfo页面统一处理-->
            <el-tooltip effect="dark" v-if="+$route.query.signStatus !== 3">
              <p slot="content" style="width: 200px; line-height: 1.5">
                批量签署规则：
                <br />1、当前签署方必须有固定签章位置
                <br />2、当前签署方不需要进行身份认证
                <br />3、当前签署方不包含强制阅读、强制现场
                <br />4、当前签署方不需要支付费用
              </p>
              <el-button @click="batchSign" size="small">批量签署</el-button>
            </el-tooltip>
            <el-button v-if="+$route.query.signStatus !== 2" @click="batchDown" size="small">下载</el-button>
            <el-button @click="emitFn('saveToDir')" size="small">归档</el-button>
          </template>
          <template v-else>
            <el-button @click="delSignTabList" size="mini">删除</el-button>
            <el-button v-if="+$route.query.signStatus !== 2" @click="batchDown" size="mini">下载</el-button>
            <el-tooltip effect="dark" v-if="+$route.query.signStatus !== 3">
              <p slot="content" style="width: 200px; line-height: 1.5">
                批量签署规则：
                <br />1、当前签署方必须有固定签章位置
                <br />2、当前签署方不需要进行身份认证
                <br />3、当前签署方不包含强制阅读、强制现场
                <br />4、当前签署方不需要支付费用
              </p>
              <el-button @click="batchSign" size="mini">批量签署</el-button>
            </el-tooltip>
            <el-button @click="emitFn('saveToDir')" size="mini">归档</el-button>
          </template>
        </el-col>
        <el-col :span="17" class="page-flex-end">
          <el-pagination
            small
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="screenParme.itemPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="screenParme.pageSize"
            :pager-count="5"
            layout="sizes, prev, pager, next, total"
            :total="screenParme.pageTotal"
          />
          <el-go
            :page-size="screenParme.pageSize"
            :total="screenParme.pageTotal"
            @current-change="handleCurrentChange"
          ></el-go>
        </el-col>
      </el-row>
    </template>
    <!-- 我仅是发起人   -->
    <template v-else>
      <applyListNew />
    </template>

    <!--购买保险-->
    <el-dialog
      title="购买保险"
      :visible.sync="insureProductDialog"
      width="700px"
      v-loading="loading"
      class="insurance-dialog"
    >
      <el-form :data="insureProduct" size="small" class="insurance-form" label-width="120px">
        <h1>合同诉讼险</h1>
        <el-alert style="margin: 10px 0" :closable="false" type="info">
          <p>
            <span class="span-important">重要</span>
            理赔说明：主要用于赔付公证费、鉴定费、仲裁、诉讼费、执行费、送达费等费用，最高可赔付
            <span
              class="span-important-color"
            >10000元</span>。
          </p>
        </el-alert>
        <el-form-item label="合同名称：">
          <el-tooltip
            effect="dark"
            placement="bottom-start"
            :disabled="insureProduct.contractName.length < 26"
          >
            <div slot="content" v-html="transferFormat(insureProduct.contractName, 30)"></div>
            <span>{{ insureProduct.contractName | ellipsis(26) }}</span>
          </el-tooltip>
        </el-form-item>
        <el-form-item label="合同编号：">{{ insureProduct.applyNo }}</el-form-item>
        <el-form-item label="被保人：">{{ insureProduct.signatoryFullName }}</el-form-item>
        <el-form-item label="参保年限：">
          <el-select v-model="insureProduct.insureYear">
            <el-option :value="1" label="1年" />
            <el-option :value="2" label="2年" />
            <el-option :value="3" label="3年" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-checkbox
            class="custom-checkbox"
            :checked="true"
            @change="
              (checked) =>
                checked
                  ? (buyInsuranceDisabled = false)
                  : (buyInsuranceDisabled = true)
            "
          >
            已阅读并同意
            <nuxt-link
              to="/insure/userNotes"
              target="_blank"
              name="userNotesBtn"
              class="color-primary"
            >《投保须知》</nuxt-link>
          </el-checkbox>
        </el-form-item>
        <el-form-item>
          <el-button
            :disabled="buyInsuranceDisabled"
            @click="toBayInsure"
            type="danger"
            class="btn"
          >购买</el-button>
        </el-form-item>
        <p class="text-info">
          注：请在合同签署完成
          <span class="span-important-color">3天之内</span>购买保险，一次最多购买
          <span class="span-important-color">3年</span>的保险。
        </p>
      </el-form>
    </el-dialog>
    <!--保险信息-->
    <el-dialog
      title="投保信息"
      :visible.sync="insureDialogVisible"
      width="550px"
      class="insurance-info"
    >
      <div class="info-box" v-if="insureDetail">
        <p style="margin-bottom: 20px">
          <span class="title">保险单号:</span>
          <span class="box">{{ insureDetail.insuranceNo }}</span>
          <a
            :href="insureDetail.url"
            class="color-success"
            style="color: #ec1c1c; margin-left: 30px"
            target="_blank"
          >查看保单>></a>
        </p>
        <p style="margin-bottom: 20px">
          <span class="title">被保人:</span>
          <span class="box">{{ insureDetail.recognizeeName }}</span>
        </p>
        <!--<p style="margin-bottom: 20px;"><span class="title">保费:</span><span class="box">{{insureDetail.preserveCost}}元</span></p>-->
        <p style="margin-bottom: 20px">
          <span class="title">赔偿限额:</span>
          <span class="box">10000元</span>
        </p>
        <p style="margin-bottom: 20px">
          <span class="title">保险期限:</span>
          <span class="box">{{ insureDetail.startTime }}至{{ insureDetail.endTime }}</span>
        </p>
        <p>
          <span class="title">理赔热线:</span>
          <span class="box">
            95556
            <nuxt-link
              to="/signInfo/insureClaim"
              target="_blank"
              style="color: #ec1c1c; margin-left: 30px"
              class="color-success"
            >查看理赔指南>></nuxt-link>
          </span>
        </p>
      </div>
    </el-dialog>

    <!--标签管理-->
    <tag-manage @close="getTagList" @refresh="getSignLists" ref="tagManage" />
    <certiServiceDialog
      v-if="cSDialogVisible"
      :dialogVisible="cSDialogVisible"
      listType="userList"
      :param="cSDialogData"
      @setCSDialogData="onSetCSDialogData"
    ></certiServiceDialog>

    <!--履约文件-->
    <el-dialog title="履约文件" :visible.sync="lYDialogVisible" width="850px" class="ly-info">
      <el-tabs v-model="activeName" class="ly-mask" @tab-click="handleClick">
        <el-tab-pane label="上传原文件" name="1">
          <p class="tips">支持常见图片、文档、视频、音频、压缩包格式，上传后会保存原文件，单个文件大小不超过30MB</p>
          <div class="box-wrap">
            <div class="temone add">
              <span class="el-icon-plus"></span>
              <input ref="referenceUpload" type="file" class="file-ipt" @change="handleInputChange" />
            </div>

            <div class="temone" v-for="(item, idx) in lYDialogData" :key="idx">
              <div class="t-box">
                <img class="y-img" src="/images/web/file-icon.png" />
                <div class="msk">
                  <span class="des">上传人：{{ item.userName }} -{{ item.accountName }}</span>
                </div>
              </div>

              <div class="a-btn">
                <a class="has-hover" :href="downloadLYFile(item.file)">下载</a>
                <a v-if="isDoc(item)" class="has-hover" @click="previewDoc(item)">预览</a>
                <a v-if="isVideoOrImg(item)" class="has-hover" @click="previewVideOrImg(item)">预览</a>
                <a v-if="item.canDelete" class="has-hover" @click="delLYFile(item)">删除</a>
                <a class="no-hover">{{ item.fileName }}</a>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="上传文件哈希" name="2">
          <p class="tips">格式没有限制，仅保存上传文件的特征值（哈希），不对文件本身做保存，单个文件大小不超过500M</p>

          <div class="box-wrap">
            <div class="temone add">
              <span class="el-icon-plus"></span>
              <input
                ref="referenceUpload1"
                type="file"
                class="file-ipt"
                @change="handleInputChange"
              />
            </div>

            <div class="temone" v-for="(item, idx) in lYDialogData" :key="idx">
              <div class="t-box">
                <img class="y-img" src="/images/web/hash-icon.png" />
                <div class="msk">
                  <span class="des">上传人：{{ item.userName }} -{{ item.accountName }}</span>
                  <br />
                  <span class="des" style="margin: 0">备案号：{{ item.presId }}</span>
                </div>
              </div>

              <div class="a-btn">
                <a class="has-hover" @click="validLYFile(item)">验证</a>
                <a v-if="item.canDelete" class="has-hover" @click="delLYFile(item)">删除</a>
                <a class="no-hover">{{ item.fileName }}</a>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>

      <div slot="footer" class="footer">
        <span class="num">
          文件数：
          <label>{{ lYDialogData.length }}</label>个
        </span>
        <el-button
          type="primary"
          size="small"
          class="cancel-btn"
          @click="lYDialogVisible = false"
        >关闭</el-button>
      </div>
    </el-dialog>
    <!--  提示展示批量签署时提醒签章   -->
    <el-dialog title="系统提示" :visible.sync="multiBatchDialogVisible" width="30%">
      <div class="batch-tips">
        <p style="padding: 20px">
          <i class="el-icon-info" style="margin-right: 10px; font-size: 20px"></i>
          确定使用以下印章，对 “{{ batchContractName }}” 等
          {{ signInfoIdsLength }}
          份文件加盖图形章，请选择：
        </p>
        <div class="temone-box">
          <div class="temone" v-for="(item, i) of defaultChapter" :key="i">
            <div
              class="t-box"
              :class="{
                'active-chap':
                  checkChapter && checkChapter.signId === item.signId,
              }"
              @click="checkUseChap(item)"
            >
              <template v-if="item.hasOwnProperty('signUrl')">
                <img class="y-img" :src="fileOperShow(item.signUrl)" />
              </template>
              <template v-else>
                <img class="y-img" :src="'data:image/jpeg;base64,' + item.signName" />
              </template>
            </div>
            <p>
              {{
              item.hasOwnProperty("signUrl")
              ? `${item.signName}(ID:${item.signId})`
              : "系统图形章"
              }}
            </p>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- <a href="/tpl/personSet" style="float: left">去更换默认章>></a> -->
        <el-button
          style="color: #1b1b1b; background: #fff"
          size="small"
          @click="multiBatchDialogVisible = false"
        >取 消</el-button>
        <el-button size="small" type="primary" @click="batchSignAll">确 定</el-button>
      </span>
    </el-dialog>
    <!--pdf文件预览-->
    <ViewFilesToDoc
      :visibleShow="visibleShowEnclosureDoc"
      :enclosurePreviewNumItem="enclosurePreviewNumItem"
      @setViewFilesToDocDialogData="onSetViewFilesToDocDialogData"
    />
    <!--附件图片video预览显示-->
    <ViewFilesToImg
      :visibleShow="visibleShowEnclosure"
      :isRefresh="isRefresh"
      :enclosurePreviewNumItem="enclosurePreviewNumItem"
      :imgList="getEnclosureImgList"
      @setViewFilesToImgDialogData="onSetViewFilesToImgDialogData"
      style="text-align: center"
    />
    <!--  提示展示批量签署时提醒签章   -->
    <el-dialog
      :visible.sync="nodeQueryVisible"
      width="800px"
      custom-class="data-dialog"
      destroy-on-close
    >
      <div class="node_header" slot="title">保全链节点查询</div>
      <p style="padding: 10px">当前合同备案号：{{ vpresId }}</p>
      <node-query :vpresId="vpresId" />
    </el-dialog>
    <!--修改手写章二维码-->
    <el-dialog
      :visible.sync="visibleSealDialog"
      width="340px"
      class="modifi-seal"
    >
      <template v-if="handWritingChapterInfo">
        <qrcode-vue
          :value="handWritingChapterInfo.url"
          :size="300"
          leave="H"
          key="seal"
        />
        <p class="text-center" style="font-size: 12px; margin-bottom: 15px">
          请使用手机扫码设置签字！
        </p>
        <el-button type="primary" size="small" style="width: 100%" @click="addUserLocalSignFn">图片上传</el-button>
      </template>
    </el-dialog>
<!--  上传图片  -->
    <userLocalSeal v-if="userLocalAddSign" :newSign="handWritingChapterInfo" @signCreated="signCreated"></userLocalSeal>
  </div>
</template>

<script>
  import QrcodeVue from "qrcode.vue";
import applyListNew from '../../pages/signInfo/applyListNew';
import navTab from '@/components/nav-tab/navTab';
import existingEvidence from "@/components/apply-list/existing-evidence";
import userLocalSeal from "../../components/tpl-editor/userLocalSeal.vue"
import {
  postSignPage,
  postSignBadge,
  delSignBySignNos,
  applyViewUrl,
  ApiMethods,
  getFindFileDownload,
  fileOperShow
} from "../../assets/js/http-serve/http-methods";
import ElGo from "../../components/go/Go";
import ApplyHandles from "@/components/apply-list/handles";
import moreButton from "@/components/apply-list/more-button";
import certiServicepopover from "@/components/apply-list/certiServicepopover";
import ApplyName from "@/components/apply-list/contractName";
import TagManage from "@/components/tag-manage";
import InsureController from "@/assets/js/http-serve/insuranceController";
import CertiServiceDialog from "@/components/apply-list/certiServiceDialog";
import ViewFilesToDoc from "@/components/viewFiles/ViewFilesToDoc";
import ViewFilesToImg from "@/components/viewFiles/ViewFilesToImg";
import sha512Crypto from "js-sha512";
import EntSignController from "../../assets/js/http-serve/entSignController";
import Clipboard from "clipboard";
import nodeQuery from "@/components/signInfo/node-query";
import { isInDingTalk } from "@/assets/js/utils/ding-env";
  import GlobalConfig from "../../assets/js/config/global";

export default {
  components: {
    applyListNew,
    navTab,
    existingEvidence,
    ElGo,
    ApplyHandles,
    moreButton,
    certiServicepopover,
    ApplyName,
    TagManage,
    CertiServiceDialog,
    ViewFilesToDoc,
    ViewFilesToImg,
    nodeQuery,
    userLocalSeal,
    QrcodeVue,
  },
  data () {
    return {
      //手写签字弹窗
      visibleSealDialog: false, //false二维码弹窗
      handWritingChapterInfo: {},//手写章二维码数据
      userLocalAddSign: false, //上传图片
      sealSignTimes: null, //签字轮询监听

      isInDingTalk,
      navTabVal: 'corpMySign',
      fileOperShow,
      visiDown: {
        status: false,
        rowApplyId: ""
      }, // 下拉菜单显示状态
      expandKeys: [], //展开行
      getDTag: false,
      cSDialogVisible: false, //证书弹出框显示
      cSDialogData: {}, //证书弹出框数据
      tagLists: [],
      // 购买保险按钮disabled
      buyInsuranceDisabled: false,
      // 签署列表
      tableList: [],
      // 筛选
      screenParme: {
        itemPage: 1,
        pageSize: 10,
        pageTotal: 0,
        dateType: null,
        beginDate: null,
        endDate: null,
        applyNo: null,
        signNo: null,
        contractName: null,
        signatoryFullName: null,
        signatoryMobile: null,
        signatoryIdentityCard: null,
        signStatusSet: null,
        ebqUserName: null,
        vpresId: null
      },
      showTag: true,
      selectedParm: "contractName",
      selectedStatus: "",
      selectedParmInfo: "",
      datePikerArr: null,
      batchLength: null, // 勾选合同数
      // 批量删除收到的签署
      signNoList: [],
      signNos: "",
      signInfoIds: "",
      batchApplyNos: "",
      batchContractName: "",
      badge: 0,
      signStatus: null,
      directoryId: null,
      signStatusSet: "",
      loading: null,
      // 保险信息弹窗
      insureDetail: null,
      insureDialogVisible: false,
      // 购买保险弹窗信息
      insureProduct: {
        contractName: "",
        signNo: "",
        applyNo: "",
        signatoryFullName: "",
        price: 0,
        insureYear: 1
      },
      insureProductDialog: false,

      //履约文件数据
      lYDialogVisible: false, //履约文件弹窗
      lYDialogData: [], //履约文件列表
      activeName: "1", //1：文件上传，2：hash值上传
      visibleShowEnclosure: false,
      visibleShowEnclosureDoc: false,
      enclosurePreviewNumItem: {}, // 当前预览项
      isRefresh: true, // 预览附件时，强制刷新
      rowData: {},
      // 993需求 新增批量签署时提示默认章
      multiBatchDialogVisible: false,
      defaultChapter: null,
      checkChapter: null, // 选择的签章
      nodeQueryVisible: false, //节点查询
      vpresId: "" // 备案号传入节点查询组件
    };
  },
  beforeMount () {
    // 特别处理：君子签首页进入，但当前账户是集团用户的情况
    if (
      this.$store.getters.currentAuthUser &&
      this.$store.getters.currentAuthUser.corpUserId &&
      !this.$store.getters.currentAuthUser.superFlag
    ) {
      this.$router.push({
        path: "/corp/signInfo/signList",
        query: { signStatus: 4 }
      });
    }
  },
  created () {
    this.getChapterList();
  },
  mounted () {
    let query = this.$route.query;
    if (query.mySendTo) {
      this.navTabVal = 'mySendTo';
    }
    this.signStatus = query ? ~~query.signStatus : null;
    this.directoryId = query ? query.directoryId : null;
    this.getTagList();
  },
  beforeDestroy() {
    this.sealSignTimes && clearInterval(this.sealSignTimes);
    this.sealSignTimes = null;
  },
  destroyed () {
    this.batchLength = null;
    this.$emit("batchLength", this.batchLength);
  },
  computed: {
    signInfoIdsLength () {
      return this.signInfoIds.split(",").length;
    },
    statusEnum () {
      if (this.$route.query.signStatus == "2") {
        return [
          {
            label: "全部",
            value: "-1"
          },
          {
            label: "待我签",
            value: "0"
          },
          {
            label: "待ta签",
            value: "1"
          }
        ];
      } else if (this.$route.query.signStatus == "3") {
        return [
          {
            label: "全部",
            value: "-1"
          },
          {
            label: "已完成",
            value: "2"
          },
          {
            label: "已拒签",
            value: "3"
          },
          {
            label: "已过期",
            value: "4"
          },
          {
            label: "已撤销",
            value: "5"
          },
          {
            label: "已作废",
            value: "6"
          }
        ];
      } else {
        return [
          {
            label: "全部",
            value: "-1"
          },
          {
            label: "待我签",
            value: "0"
          },
          {
            label: "待ta签",
            value: "1"
          },
          {
            label: "已完成",
            value: "2"
          },
          {
            label: "已拒签",
            value: "3"
          },
          {
            label: "已过期",
            value: "4"
          },
          {
            label: "已撤销",
            value: "5"
          }
        ];
      }
    },
    // 获取附件中的图片列表，用于预览
    getEnclosureImgList () {
      let a = this.lYDialogData.filter(item => {
        return this.isVideoOrImg(item);
      });
      return a;
    }
  },
  watch: {
    datePikerArr: {
      handler (val) {
        if (val && val.length === 2) {
          this.screenParme.beginDate = val[0];
          this.screenParme.endDate = val[1];
        } else {
          this.screenParme.beginDate = this.screenParme.endDate = null;
        }
      },
      deep: true
    },
    selectedParm: function (newVal, oldVal) {
      this.screenParme[newVal] = this.screenParme[oldVal];
      this.screenParme[oldVal] = null;
    },
    selectedParmInfo: function (val) {
      this.screenParme[this.selectedParm] = val;
    },
    selectedStatus: function (val) {
      this.screenParme["selfSign"] = null;
      this.screenParme["signStatusSet"] = this.signStatusSet;
      switch (val) {
        case "0":
          this.screenParme["signStatusSet"] = "0";
          this.screenParme["selfSign"] = 1;
          break;
        case "1":
          this.screenParme["signStatusSet"] = "0";
          this.screenParme["selfSign"] = 0;
          break;
        case "2":
          this.screenParme["signStatusSet"] = "1";
          break;
        case "3":
          this.screenParme["signStatusSet"] = "2";
          break;
        case "4":
          this.screenParme["signStatusSet"] = "-6";
          break;
        case "5":
          this.screenParme["signStatusSet"] = "-5";
          break;
        case "6":
          this.screenParme["signStatusSet"] = "4";
          break;
      }
    },
    signStatusSet: function (val) {
      let json = {
        itemPage: 1,
        pageSize: 10,
        dateType: null,
        beginDate: null,
        endDate: null,
        applyNo: null,
        signNo: null,
        contractName: null,
        signatoryFullName: null,
        signatoryMobile: null,
        signatoryIdentityCard: null,
        vpresId: null,
        signStatusSet: val,
        ebqUserName: null
      };

      this.screenParme = Object.assign(this.screenParme, json);
      this.getSignLists();
    },
    signStatus (val) {
      this.signNos = ""; // 切换页面时（未完成、已结束、收件箱），要重置已选中
      this.selectedStatus = "";
      this.screenParme.selfSign = null;
      switch (val) {
        case 1: // 全部
          this.signStatusSet = "";
          break;
        case 2: // 未完成
          this.signStatusSet = "-1,0";
          break;
        case 3: // 已结束
          this.signStatusSet = "1,2,4,-5,-6";
          break;
        default:
          this.signStatusSet = "";
          break;
      }
    },
    directoryId (val) {
      this.screenParme["directoryId"] = val;
      this.getSignLists();
    },
    $route: {
      handler () {
        this.resetScreenParams();
        let query = this.$route.query;
        this.signStatus = query ? ~~query.signStatus : null;
        this.directoryId = query ? query.directoryId : null;
      },
      deep: true
    }
  },
  methods: {
    //打开手写章二维码
    handWritingChapterEdit (handSignCnt) {
      //newSign
      ApiMethods.UserTagController.getSignatureParams().then(respon => {
        let obj = respon;
        if (typeof obj === "string") {
          obj = eval("(" + obj + ")");
        }
        if (obj.success === true || obj.success === "true") {
          let data = obj.data;
          ApiMethods.UserTagController.hasManualSignatureObj(data).then(res => {
            res = res.data;
            const currentAuthUser = this.$store.getters.currentAuthUser
            const signName = currentAuthUser.name
            let url = `${GlobalConfig.domain.junziqianH5Op}/handSign?signNo=${data.signNo}&sign=${data.sign}&ts=${data.ts}&uid=${data.uid}&formTo=personSet&signName=${signName}`;
            url += res.updateTime ? `&updateTime=${res.updateTime}` : "";
            this.handWritingChapterInfo = {
              url: url,
              ts: data.ts,
              sign: data.sign,
              signNo: data.signNo,
              updateTime: res.updateTime || "",
              formTo: "personSet",
              uid: data.uid,
            };
            //如果已经设置过手写了
            if(res.handSignUrl){
              if (+handSignCnt === +this.batchLength) {
                this.$confirm('确认签署', "提示", {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning",
                  customClass: "handle-message"
                }).then(() => {
                  this.batchSignAll();
                }).catch(() => {})
              } else {
                this.multiBatchDialogVisible = true;
                this.handWritingChapterInfo.signUrl = `${GlobalConfig.domain.junziqianH5Op}/fileOper/show?targetId=${res.handSignUrl.targetId}&fileType=${res.handSignUrl.fileType}&sign=${res.handSignUrl.sign}&ts=${res.handSignUrl.ts}`
              }
            } else { //未设置手写
              this.visibleSealDialog = true;
              if (!this.sealSignTimes) {
                this.sealSignTimes = setInterval(() => {
                  this.isSealModifi();
                }, 3000)
              }
            }
          });
        } else {
          this.$message.error(res.description);
        }
      });
    },
    //轮询
    isSealModifi() {
      if (!this.handWritingChapterInfo) return false;
      ApiMethods.UserTagController.pollingSignatureStatus(
        this.handWritingChapterInfo
      )
        .then(({ data }) => {
          if (data || data === "true") {
            this.signCreated();
          }
        })
        .catch(err => {
          this.$message.error(err.description || "数据初始化失败");
        });
    },
    // 创建签章成功
    signCreated(refresh){
      //清除监听
      this.sealSignTimes && clearInterval(this.sealSignTimes);
      this.sealSignTimes = null;
      //关闭签字弹窗
      this.visibleSealDialog = false;
      //关闭上传文件弹窗
      this.userLocalAddSign = false
      //重新调用批量签署
      this.batchSign();
    },
    //个人签字上传图片
    addUserLocalSignFn() {
      this.handWritingChapterInfo.uid = "";
      this.userLocalAddSign = true;
    },
    // 查看作废协议（合同作废发起使用的是pc多文件发起，默认走多文件查看页面）
    toApplyDetail (row) {
      if (row.applySignCreateType === 0 && row.applySignDealType === 6) {
        return this.$message.error('该合同仅是hash保全，无法查看合同内容');
      }
      let funLoading = null;
      if (this.$store.getters.authUser.identityAuth > -1) {
        let param = {
          signNo: row.signNo,
          applyNo: row.terminationApplyNo,
          multiFile: 1
        };
        funLoading = this.$loading({ lock: true });
        applyViewUrl(param)
          .then(url => {
            funLoading.close();
            isInDingTalk ? location.href = url : window.open(url)
          })
          .catch(err => {
            console.log('err', err);
            funLoading.close();
            this.$message.error(err.description || "无法查看该合同");
            console.error("toApplyDetail: " + JSON.stringify(err));
          });
      }
    },
    checkUseChap (chap) {
      this.checkChapter = chap
    },
    //归档
    emitFn (fn) {
      if (!this.batchLength) return this.$message.warning('请选择要归档的文件')
      this.$emit("emitFn", fn);
    },
    visiChange (val, rowApplyId) {
      this.visiDown = {
        status: val,
        rowApplyId
      };
    },
    //更多按钮展开
    moreBtnShowFn (obj) {
      if (this.expandKeys[0] === obj.applyId) {
        this.expandKeys = [];
      } else {
        this.expandKeys = [obj.applyId];
      }
    },
    // 复制并查询
    copyTextToQuery (vpresId) {
      this.vpresId = vpresId;
      this.nodeQueryVisible = true;
    },
    // 获取章列表933 需求获取默认章
    getChapterList () {
      EntSignController.getAllPreSeal()
        .then(data => {
          this.defaultChapter = data.data
        })
        .catch(err => console.log(err));
    },
    getTagList () {
      ApiMethods.UserTagController.getAllUserTagList().then(res => {
        if (!res.success && this.$store.getters.authUser.identityAuth > -1)
          return this.$message.error(res.description || this.$tip);
        if ((res.data || []).length === 0 && !this.getDTag)
          return this.getDefaultTag();
        this.tagLists = res.data;
      });
    },
    getDefaultTag () {
      this.getDTag = true;
      ApiMethods.UserTagController.getDefaultTag().then(res => {
        if (!res.success && this.$store.getters.authUser.identityAuth > -1)
          return this.$message.error(res.description || this.$tip);
        this.getTagList();
      });
    },
    setTag (tag, row) {
      this.$refs.tagManage.setTag(tag, row, 1).then(res => {
        if (!res.success)
          return this.$message.error(res.description || "操作失败");
        this.$set(row, "tag", []);
        tag && row.tag.push(tag);
      });
    },
    cellMouseEnter (row) {
      this.$set(row, "showTag", true);
    },
    cellMouseLeave (row) {
      row.showTag = false;
    },
    showTagManage () {
      this.$refs.tagManage.setVisible(true);
    },
    resetScreenParams () {
      this.selectedParm = "contractName";
      this.selectedParmInfo = "";
      this.selectedStatus = "";
      this.screenParme = {
        itemPage: 1,
        pageSize: 10,
        pageTotal: 0,
        dateType: null,
        beginDate: null,
        endDate: null,
        applyNo: null,
        signNo: null,
        contractName: null,
        signatoryFullName: null,
        signatoryMobile: null,
        signatoryIdentityCard: null,
        signStatusSet: null,
        ebqUserName: null,
        vpresId: null
      };
      this.datePikerArr = null;
      this.signStatus = this.$route.query ? (+this.$route.query.signStatus) : null;
      this.directoryId = null;
    },
    // 重置
    async rest () {
      this.selectedParm = "contractName";
      this.selectedParmInfo = "";
      this.selectedStatus = "";
      this.screenParme = {
        itemPage: 1,
        pageSize: 10,
        pageTotal: 0,
        dateType: null,
        beginDate: null,
        endDate: null,
        applyNo: null,
        signNo: null,
        contractName: null,
        signatoryFullName: null,
        signatoryMobile: null,
        signatoryIdentityCard: null,
        signStatusSet: null,
        ebqUserName: null,
        vpresId: null
      };
      this.datePikerArr = null;
      this.directoryId = null;
      await this.signStatusChangeFn();
      await this.findScreenSign();
    },
    signStatusChangeFn () {
      switch (this.signStatus) {
        case 1: // 全部
          this.signStatusSet = "";
          break;
        case 2: // 未完成
          this.signStatusSet = "-1,0";
          break;
        case 3: // 已结束
          this.signStatusSet = "1,2,4,-5,-6";
          break;
        default:
          this.signStatusSet = "";
          break;
      }
      this.screenParme["signStatusSet"] = this.signStatusSet;
    },
    // 查找筛选
    findScreenSign: function (screen) {
      // console.log(screen)
      if (screen) {
        this.screenParme.itemPage = screen.itemPage;
        this.screenParme.pageSize = screen.pageSize;
      } else {
        this.screenParme.itemPage = 1;
        this.screenParme.pageSize = 10;
      }
      this.getSignLists();
    },
    // 获取签署列表
    getSignLists: function () {
      this.loading = true;
      this.batchLength = null;
      this.$emit("batchLength", this.batchLength);
      this.screenParme.currentDirData = null;
      (this.$route.query.match == "-1" || this.$route.query.directoryId) &&
        (this.screenParme.currentDirData = 1);
      postSignPage(this.screenParme)
        .then(data => {
          this.screenParme.pageSize = data.pageSize;
          this.screenParme.itemPage = data.pageNum;
          this.screenParme.pageTotal = data.total;
          this.tableList = data.data;
          if (window.location.href.indexOf("match") > -1) {
            this.getSignBadge();
          } else {
            this.badge = data.total;
            this.$emit("update:badge", data.total);
          }
        })
        .catch(e => { })
        .finally(() => {
          this.loading = false;
        });
    },
    getSignBadge: function () {
      postSignBadge(this.screenParme).then(data => {
        this.badge = data.data;
        this.$emit("update:badge", data.data);
      });
    },
    // 分页
    handleSizeChange (val) {
      this.screenParme.itemPage = 1;
      this.screenParme.pageSize = val;
      this.getSignLists();
    },
    handleCurrentChange (val) {
      this.screenParme.itemPage = val;
      this.getSignLists();
    },
    // 批量勾选签署列表
    handleSelectionChange: function (val) {
      //清除定时器
      this.sealSignTimes && clearInterval(this.sealSignTimes);
      this.sealSignTimes = null;

      this.batchLength = val.length;
      this.$emit("batchLength", this.batchLength);
      this.signNos = "";
      this.batchContractName = "";
      this.signInfoIds = "";
      this.batchApplyNos = "";
      if (!val || !val.length) return;
      let signNosArr = [];

      val.forEach(t => {
        signNosArr.push(t.signInfoNo);
      });
      this.signNoList = val
      this.signInfoIds = (val || []).map(i => i.signInfoId).join(",");
      this.batchApplyNos = (val || []).map(i => i.applyNo).join(",");
      this.signNos = signNosArr.join(",");
      this.batchContractName = val[0].contractName;
    },
    // 删除批量勾选的签署列表
    delSignTabList () {
      if (!this.signNos)
        return this.$confirm("请勾选要删除的签署信息。", "系统提示", {
          showConfirmButton: true,
          showCancelButton: false
        });

      this.$confirm("该操作删除后的合同将无法恢复，确认删除？", "系统提示", {
        showCancelButton: true,
        type: "info"
      })
        .then(() => {
          delSignBySignNos(this.signNos, "")
            .then(data => {
              this.$message.success("合同删除成功");
              this.getSignLists();
            })
            .catch(err => {
              this.$message.error(
                err.description || "删除信息失败，请刷新后再试！"
              );
              console.error("删除签署信息：" + JSON.stringify(err));
            });
        })
        .catch(() => { });
    },
    batchDown () {
      if (!this.batchApplyNos)
        return this.$confirm("请先选择需要下载的签署。", "系统提示", {
          showConfirmButton: true,
          showCancelButton: false
        });
      this.loading = true;
      ApiMethods.UseEnterpriseController.downloadBatch({
        applyNos: this.batchApplyNos
      })
        .then(res => {
          if (!res.success)
            return this.$message.error(res.description || this.$tip);
          this.downloadFile(res.data);
        })
        .finally(() => (this.loading = false));
    },
    async downloadFile (param) {
      param.fix = ".zip";
      let res = await ApiMethods.FileOperController.download_get(param);
      if (res.success && res.url) {
        window.location.href = res.url;
      } else {
        this.$message.error(res.err);
      }
    },
    batchSignAll () {
      // if (!this.checkChapter) return this.$message.error('请选择要使用的签章')
      this.multiBatchDialogVisible = false;
      this.loading = true;
      const params = {
        signInfoIds: this.signInfoIds,
      }
      if (this.checkChapter && this.checkChapter.signId) {
        params.signId = this.checkChapter.signId
      }
      ApiMethods.SendSms4SignController.batchSign(params)
        .then(res => {
          if (!res.success) {
            if (!((res.data || {}).noPassContract || [])[0])
              return this.$message.error(res.description || this.$tip);
            return this.$confirm(
              `"${(res.data || {}).noPassContract[0].contractName}"等${(res.data || {}).noPassContract.length
              }
                份合同不符合批量签署规则，请重新选择`,
              "系统提示",
              {
                showCancelButton: true,
                type: "info"
              }
            ).then(() => { });
          }
          this.signNoList = []
          this.$message.success("批量签署成功");
          this.getSignLists();
        })
        .finally(() => (this.loading = false));
    },
    async batchSign () {
      if (this.signNoList.length === 0)
        return this.$confirm("请先勾选需要签署的文件。", "系统提示", {
          showConfirmButton: true,
          showCancelButton: false
        });
      const signOthers = this.signNoList.filter(item => {
        return item.selfSign !== 1 || item.signInfoStatus !== 0
      })
      if (signOthers.length > 0) {
        const text = `【${signOthers[0].contractName}】等${signOthers.length} 份已勾选合同不是【待我签】或不是【待签流程】`
        return this.$confirm(text, "系统提示", {
          showConfirmButton: true,
          showCancelButton: false
        }).then(() => {}).catch(() => {})
      }
      const ruleRes = await ApiMethods.SignInfoController.batchSignRule({
        signInfoIds: this.signInfoIds
      })
      if (!ruleRes.success) {
        if (!((ruleRes.data || {}).noPassContract || [])[0])
          return this.$message.error(ruleRes.description || this.$tip);
        return this.$confirm(
          `"${(ruleRes.data || {}).noPassContract[0].contractName}"等${(ruleRes.data || {}).noPassContract.length
          }
                份合同不符合批量签署规则，请重新选择`,
          "系统提示",
          {
            showConfirmButton: true,
            showCancelButton: false,
            type: "info"
          }
        ).then(() => { });
      } else if (ruleRes.data && ruleRes.data.handSignCnt) {
        this.handWritingChapterEdit(ruleRes.data.handSignCnt);
      } else {
        this.multiBatchDialogVisible = true;
        if (+ruleRes.data.handSignCnt === +this.batchLength) {
          this.$confirm('确认签署', "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            customClass: "handle-message"
          }).then(() => {
            this.batchSignAll();
          }).catch(() => {})
        } else {
          this.multiBatchDialogVisible = true;
        }
      }
    },
    /**
     * @param value value
     * @param space space
     */
    transferFormat (value, space) {
      if (typeof space !== "number") {
        return value;
      }
      if (value.length < space) return value;
      let v = "";
      for (let index = 0; index < value.length; index++) {
        if (index > 0 && index % space === 0) {
          v += "<br/>";
        }
        v += value[index];
      }
      return v;
    },
    // 点击保险按钮
    handleInsurance (signInfo) {
      let insureState = signInfo.insureState;
      if (insureState === 0) {
        this.getInsureProduct(signInfo.signNo);
      } else if (insureState === 1 || insureState === 2) {
        this.getInsureDetail(signInfo.preservationId);
      }
    },
    // 获取保险信息
    getInsureDetail (preservationId) {
      InsureController.detail(preservationId)
        .then(({ data }) => {
          if (data) {
            this.insureDetail = data;
            this.insureDialogVisible = true;
          }
        })
        .catch(err => {
          this.$message.warning(err.description);
          console.error("购买保险：" + JSON.stringify(err));
        });
    },
    // 获取合同保险单价
    getInsureProduct (signNo) {
      InsureController.productInfo(signNo)
        .then(({ data }) => {
          if (data) {
            this.insureProduct = {
              contractName: data.contractName,
              signNo: data.signNo,
              applyNo: data.applyNo,
              signatoryFullName: data.signatoryFullName,
              price: data.jzqInsurePreserveCost,
              insureYear: 1
            };
            this.insureProductDialog = true;
          }
        })
        .catch(err => {
          this.$message.warning(
            "已超过购保受理期。保险公司只在签署完成后的3个自然日内受理投保，超过时间将不予受理"
          );
        });
    },
    // 购买保险
    toBayInsure () {
      let param = {
        signNo: this.insureProduct.signNo,
        insureYear: this.insureProduct.insureYear,
        returnURL: window.location.href,
        ifMobile: 0
      };
      InsureController.order(param)
        .then(res => {
          if (!res.success)
            return this.$message.error(res.description || this.$tip);
          if (res.data.recharge) {
            this.$jzqService.pointRechargeTip(); // 积分不足时的充值提示
          } else {
            this.$confirm(`购买保险需消耗${res.data.point}积分`, "支付提示", {
              showConfirmButton: true,
              showCancelButton: true,
              type: "info"
            }).then(() => {
              this.loading = true;
              InsureController.order(Object.assign(param, { pay: 1 }))
                .then(res => {
                  if (+res.code === 0) {
                    this.insureProductDialog = false;
                    this.getSignLists();
                    return this.$message.success("购买保险成功");
                  }
                  if (+res.code === 10806) {
                    this.$jzqService.pointRechargeTip(); // 积分不足时的充值提示
                    return;
                  }
                  this.$message.error(res.description || "支付失败");
                })
                .catch(err => {
                  if (+err.code === 10806) {
                    this.$jzqService.pointRechargeTip(); // 积分不足时的充值提示
                    return;
                  }
                })
                .finally(() => (this.loading = false));
            });
          }
        })
        .catch(err => {
          // newWindow.close();
          this.$message.warning(err.description);
          console.error("购买保险：" + JSON.stringify(err));
        });
    },
    async openCSDialog (rowData) {
      let _this = this;
      let _param;
      let viewUrlParam = {
        signNo: rowData["signInfoNo"] || "",
        applyNo: rowData.applyNo || ""
      };
      let viewUrlRes = await ApiMethods.UserApplySignController.viewUrl(
        viewUrlParam
      );
      if (!viewUrlRes.success) {
        return _this.$message.error(viewUrlRes.description || "初始化数据失败");
      }
      _param = viewUrlRes.data;
      let certiRes = await ApiMethods.ApplySignController.certi(_param);
      if (certiRes.success) {
        this.setCSDialogData(certiRes.data);
      } else {
        _this.$message.error(certiRes.description);
      }
    },
    setCSDialogData (data) {
      this.cSDialogVisible = true;
      this.cSDialogData = data;
    },
    onSetCSDialogData (data) {
      this.cSDialogVisible = data.cSDialogVisible;
      this.cSDialogData = data.cSDialogData;
    },

    //履约文件相关 882需求新增
    openLYDialog (rowData) {
      this.lYDialogVisible = true;
      this.rowData = rowData;
      this.setLYDialogData();
    },
    //展示履约文件弹窗
    async setLYDialogData () {
      let _this = this;
      let param = {
        uploadType: this.activeName,
        applyNo: this.rowData.applyNo || ""
      };
      let res = await ApiMethods.PerformanceController.getList(param);
      if (res.success) {
        this.lYDialogData = res.data;
      } else {
        _this.$message.error(res.description);
      }
    },
    // 获取附件后缀
    getEnclosureSuffix (item) {
      if (item.fileName) {
        let arr = item.fileName.split(".");
        return arr[arr.length - 1];
      }
      return "";
    },
    // 附件是否文档
    isDoc (item) {
      let str = this.getEnclosureSuffix(item).toLocaleUpperCase();
      // let arr = ['DOCX','DOC','PDF','XLS','XLSX']
      let arr = ["PDF"];
      if (arr.indexOf(str) > -1) {
        return true;
      }
      return false;
    },
    // 附件是否图片或视频
    isVideoOrImg (item) {
      let str = this.getEnclosureSuffix(item).toLocaleUpperCase();
      // let arr = ['DOCX','DOC','PDF','XLS','XLSX']
      let arr = ["PNG", "GIF", "JPG", "JPEG", "MP4", "WEBM", "OGG"];
      if (arr.indexOf(str) > -1) {
        return true;
      }
      return false;
    },
    // 预览履约文件图片或者视频
    previewVideOrImg (item) {
      this.enclosurePreviewNumItem = item;
      this.visibleShowEnclosure = true;
      // 刷新预览弹窗，更新
      this.isRefresh = false;
      this.$nextTick(() => {
        this.isRefresh = true;
      });
    },
    // 预览履约文件文档
    previewDoc (item) {
      this.enclosurePreviewNumItem = item;
      this.visibleShowEnclosureDoc = true;
    },

    //删除履约文件
    delLYFile (item) {
      this.$confirm("该操作删除后的文件将无法恢复，确认删除？", "系统提示", {
        showCancelButton: true,
        type: "info"
      })
        .then(() => {
          ApiMethods.PerformanceController.del({
            performanceId: item.performanceId
          })
            .then(data => {
              if (data.success) {
                this.setLYDialogData();
              } else {
                _this.$message.error(data.description);
              }
            })
            .catch(err => {
              this.$message.error(
                err.description || "删除失败，请刷新后再试！"
              );
            });
        })
        .catch(() => { });
    },
    //下载履约文件
    downloadLYFile (item) {
      if (!item || item === "null" || item === "false")
        return "javascript:void(0)";
      if (item.fileName === "blob") {
        item.fileName = "attachment.png";
        item.fix = ".png";
      }
      return getFindFileDownload(item);
    },
    // 执行预览图片视频关闭后参数回传
    onSetViewFilesToImgDialogData (data) {
      this.visibleShowEnclosure = data.visibleShow;
      this.enclosurePreviewNumItem = data.obj;
    },
    // 执行预览PDF关闭后参数回传
    onSetViewFilesToDocDialogData (data) {
      this.visibleShowEnclosureDoc = data.visibleShow;
      this.enclosurePreviewNumItem = data.obj;
    },
    // 上传履约文件
    handleInputChange: function (e) {
      e = e.target;
      let param = { file: e.files[0] };
      if (!param.file) return;
      var frm = new FormData();
      if (+this.activeName == 1) {
        if (param.file.size > 30 * 1024 * 1024) {
          e.value = "";
          param = { file: "" };

          return this.$confirm(`上传的签章文件不能超过30M`, "系统提示", {
            showCancelButton: false,
            confirmButtonText: "确定",
            type: "warning"
          })
            .then(() => { })
            .catch(() => { });
        }
        frm.append("file", param.file);
        frm.append("fileName", e.files[0].name);
        frm.append("uploadType", this.activeName);
        frm.append("applyNo", this.rowData.applyNo);
        ApiMethods.PerformanceController.upload(frm)
          .then(res => {
            this.$refs.referenceUpload.value = null;
            if (res.success) {
              this.$message.success("上传成功");
              this.setLYDialogData();
            } else {
              this.$message.error(res.description);
            }
          })
          .catch(e => {
            this.$message.error(e.description);
          });
      } else {
        if (param.file.size > 500 * 1024 * 1024) {
          e.value = "";
          param = { file: "" };

          return this.$confirm(`上传的签章文件不能超过500M`, "系统提示", {
            showCancelButton: false,
            confirmButtonText: "确定",
            type: "warning"
          })
            .then(() => { })
            .catch(() => { });
        }
        let _this = this;
        let targetFileHash = "";
        const sha512 = sha512Crypto.create();
        _this.fileSliceDeal(
          e.files[0],
          1024 * 1024 * 2,
          function (fileSlice) {
            sha512.update(fileSlice);
          },
          function () {
            targetFileHash = sha512.hex();
            frm.append("hashValue", targetFileHash);
            frm.append("fileName", e.files[0].name);
            frm.append("uploadType", _this.activeName);
            frm.append("applyNo", _this.rowData.applyNo);
            ApiMethods.PerformanceController.upload(frm)
              .then(res => {
                _this.$refs.referenceUpload1.value = null;
                if (res.success) {
                  _this.$message.success("上传成功");
                  _this.setLYDialogData();
                } else {
                  _this.$message.error(res.description);
                }
              })
              .catch(e => {
                _this.$message.error(e.description);
              });
          }
        );
      }
    },
    //tab切花
    handleClick (tab) {
      this.activeName = tab.name;
      this.setLYDialogData();
    },
    //验证跳转
    validLYFile (item) {
      const url = "https://www.ebaoquan.org/query?type=2&bah=" + item.presId
      isInDingTalk ? location.href = url : window.open(url, "_blank");
    },
    //哈希需要
    fileSliceDeal: function (file, sliceSize, dealFun, finishFun) {
      var startTime = new Date().getTime();
      var chunkSize = file.size;
      var chunks = 1;
      var blobSlice =
        File.prototype.slice ||
        File.prototype.mozSlice ||
        File.prototype.webkitSlice;
      if (blobSlice) {
        chunkSize = sliceSize;
        chunks = Math.ceil(file.size / chunkSize);
      }
      var currentChunk = 0;
      var fileReader = new FileReader();
      fileReader.onload = function (e) {
        dealFun(e.target.result, currentChunk, chunks);
        currentChunk++;
        if (currentChunk < chunks) {
          loadNext();
        } else {
          finishFun();
        }
      };
      fileReader.onerror = function () {
        console.warn("oops, something went wrong.");
      };

      function loadNext () {
        var start = currentChunk * chunkSize;
        var end =
          start + chunkSize >= file.size ? file.size : start + chunkSize;
        fileReader.readAsArrayBuffer(
          blobSlice ? blobSlice.call(file, start, end) : file
        );
      }

      loadNext();
    }
  },
  name: "signList"
};
</script>
<style lang="less" scoped>
/deep/ .el-dialog__title {
  padding: 10px;
}

/deep/ .el-table__expand-icon {
  display: none !important;
}

/deep/ .el-dialog__headerbtn .el-dialog__close {
  color: #ffffff;
}

.node_header {
  height: 50px;
  line-height: 50px;
  text-align: center;
  background-color: #ed4031;
  border-radius: 6px 6px 0 0;
  background-size: 100%;
  font-size: 16px;
  color: #ffffff;
}

.batch-tips {
  width: 100%;
  display: flex;
  flex-direction: column;
  .temone-box {
    display: flex;
    flex-wrap: wrap;
    padding: 10px;
    max-height: 45vh;
    overflow-y: scroll;
    img {
      width: 7vw;
      margin: 0.5vw;
      border: 1px solid transparent;
    }
    .active-chap {
      border: 1px solid #ec1c1c;
    }
  }
}

.temone {
  width: 175px;
  text-align: center;
  align-items: center;
  margin: 15px 0 0 20px;
  border: 1px solid rgba(238, 238, 238, 1);
  border-radius: 4px;
  height: 140px;

  p {
    font-size: 14px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    padding: 0 10px;
    width: 100%;
    font-family: Source Han Sans SC;
    box-sizing: border-box;
    height: 35px;
    line-height: 35px;
    background: rgba(239, 239, 239, 1);
    color: rgba(41, 2, 2, 0.65);
  }

  .t-box {
    position: relative;
    width: 100%;
    height: 105px;
    display: flex;
    justify-content: center;
    align-items: center;
    // flex-direction: column;

    .y-img {
      width: 96px;
      height: auto;
      display: block;
      margin: 8px auto 7px auto;
    }
  }

  .el-icon-plus {
    cursor: pointer;
    color: #c9bfbf;
    font-size: 80px;
  }
}

.operate-box {
  /*  display: flex; */
  justify-content: flex-start;
  align-items: center;
  .colum {
    display: flex;
    flex-direction: column;
  }
}

.hover-win {
  padding: 5px;

  .icontag:hover {
    background: whitesmoke;
  }
}

.icontag {
  color: #ddd;
}

.multiFile {
  position: absolute;
  font-size: 12px;
  top: 0px;
  left: -12px;
  width: 22px;
  height: 16px;
  line-height: 16px;
  background-color: #eb090a;
  color: #ffffff;
  text-align: center;
  border-radius: 4px;
  transform: scale(0.8);
  z-index: 2;

  &:after {
    content: "";
    position: absolute;
    bottom: -4px;
    right: 4px;
    width: 0;
    height: 0;
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
    border-right: 5px solid #eb090a;
    z-index: 1;
  }
}

.textEllipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #290202;
  opacity: 0.65;
}

.custom-checkbox {
  /deep/ .el-checkbox__label {
    color: #606266;
  }
}

.operation span {
  display: inline-block;
  margin-right: 10px;
  cursor: pointer;
}

.insurance-info .info-box {
  padding: 0 20px 20px 20px;

  p {
    margin-bottom: 10px;
  }

  .title {
    vertical-align: top;
    display: inline-block;
    text-align: right;
    width: 100px;
    margin-right: 10px;
  }

  .box {
    display: inline-block;
  }
}

.insurance-dialog .insurance-form {
  width: 80%;
  margin: 0 auto 40px auto;

  h1 {
    text-align: center;
    font-family: "微软雅黑";
    font-size: 19px;
    font-weight: 400;
    color: #333333;
  }

  .span-important {
    padding: 0 5px;
    color: white;
    background: #ec1c1c;
    border-radius: 4px;
  }

  .span-important-color {
    color: #ec1c1c;
  }

  .pay-money {
    color: #ec1c1c;

    span {
      font-size: 22px;
    }
  }

  .btn {
    width: 220px;
  }
}

.file-name {
  display: inline-block;
  cursor: pointer;

  i {
    display: inline-block;
    width: 22px;
    height: 18px;
    position: absolute;
    top: 15px;
    left: -13px;
  }
}

.action {
  span {
    cursor: pointer;
  }
}

.query-label {
  font-weight: 600;
  white-space: nowrap;
}

.sign-list {
  max-width: 1200px;
  margin: 0 auto;

  .color-success {
    cursor: pointer;
  }

  .right-wrap {
    margin-left: 215px;
    background-color: #ffffff;

    .table-wrap {
      padding: 0 16px;
    }
  }

  .bulkOperation {
    width: 85%;
    height: 50px;
    background: #f9f9f9;
    position: absolute;
    top: 99px;
    left: 140px;
    display: flex;
    align-items: center;
    color: rgba(41, 2, 2, 0.45);

    .position1 {
      margin-left: 80px;
    }

    .position2 {
      margin-left: 10px;
    }
  }

  .pageation {
    height: 62px;
    padding: 15px;
    border-top: 0;
  }

  .dialog-footer {
    padding-bottom: 20px;

    .btn {
      width: 30%;
    }
  }

  nav.nav-bar {
    width: 100%;
    border: 1px dashed #d7d7d7;
    overflow: hidden;

    li.nav-item {
      margin-right: 14px;
      padding: 10px 15px;
      color: #666;
      border: none;
      background: #fff;
      cursor: pointer;
    }

    .nav-item.active {
      color: #ec1c1c;
    }

    ul.nav {
      width: 100%;
    }
  }
}

.tag-flag {
  display: inline-block;
  height: 18px;
  width: 19px;
  background-image: url(/images/icon/icon-flag.png);
  background-size: cover;
  background-repeat: no-repeat;
}

.tip-flag-1 {
  background-color: #faca32;
}

.tip-flag-2 {
  background-color: #71ac74;
}

.tip-flag-3 {
  background-color: #da4848;
}

.tip-flag-4 {
  background-color: #e5a196;
}

.tip-flag-5 {
  background-color: #615044;
}

.tip-flag-6 {
  background-color: #f79448;
}

.tip-flag-7 {
  background-color: #8181c1;
}

.tip-flag-8 {
  background-color: #895fa7;
}

.tip-flag-9 {
  background-color: #34699a;
}

.tip-flag-10 {
  background-color: #468a8c;
}

.flagActive {
  border: 1px solid red;
}

.ly-mask {
  .tips {
    color: rgb(115, 90, 90);
    font-size: 12px;
    text-align: left;
  }

  .box-wrap {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
    margin-left: -20px;
    margin-top: -15px;
    padding: 15px;

    &:last-child {
      /* margin-bottom: 130px; */
    }

    .temone {
      position: relative;
      margin: 15px 0 0 20px;
      width: 175px;
      text-align: center;
      border: 1px solid rgba(238, 238, 238, 1);
      border-radius: 4px;

      &.add {
        cursor: pointer;
        height: 140px;
        line-height: 140px;
        display: flex;
        justify-content: center;
        align-items: center;

        .file-ipt {
          width: inherit;
          height: inherit;
          position: absolute;
          opacity: 0;
        }

        &:hover {
          box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.28);
        }
      }

      &.temone-center {
        height: 140px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .t-box {
          width: 100%;
          height: 75%;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;

          .y-img {
            margin-top: 0;
          }
        }

        .tpid {
          width: 100%;
          height: 25%;
          background: #eeeeee;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }

      &:hover {
        .t-box {
          .msk {
            width: 100%;
            height: 100%;
            opacity: 1;
          }
        }

        .has-hover {
          display: block;
        }

        .no-hover {
          display: none;
        }
      }

      .t-box {
        position: relative;
        height: 105px;
        overflow: hidden;

        .y-img {
          width: 46px;
          height: 54px;
          display: block;
          margin: 17px auto 7px auto;
        }

        p {
          font-size: 14px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          padding: 0 10px;
          width: 100%;
          font-family: Source Han Sans SC;
          color: rgba(41, 2, 2, 0.65);
          box-sizing: border-box;
        }

        .msk {
          transition: all ease 0.2s;
          position: absolute;
          left: 0;
          top: 0;
          width: 0;
          height: 0;
          background: rgba(0, 0, 0, 0.5);
          opacity: 0;
          padding: 8px 8px;
          box-sizing: border-box;

          .des {
            margin-top: 20px;
            font-size: 12px;
            text-align: left;
          }
          p {
            color: rgba(41, 2, 2, 0.65);
          }
          span {
            cursor: pointer;
            color: #ffffff;
            margin-left: 10px;
          }
        }
      }

      .b-box {
        display: flex;
        justify-content: space-between;
        align-items: center;

        a {
          width: 50%;
        }
      }

      .el-icon-plus {
        cursor: pointer;
        color: #c9bfbf;
        font-size: 80px;
      }
    }
  }

  .a-btn {
    cursor: pointer;
    display: flex;
    justify-content: space-evenly;
    width: 100%;
    height: 35px;
    line-height: 35px;
    font-size: 14px;
    font-family: Source Han Sans SC;
    font-weight: 400;
    color: rgba(41, 2, 2, 1);
    text-decoration: none;
    border-radius: 0px 0px 4px 4px;
    background: rgba(239, 239, 239, 1);

    a {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;

      &:hover {
        color: rgba(236, 28, 28, 1);
      }
    }

    .has-hover {
      display: none;
    }

    .no-hover {
      display: block;
    }
  }
}

/deep/ .ly-info .el-tabs__item.is-active {
  color: rgb(236, 28, 28);
}

/deep/ .ly-info .el-tabs__active-bar {
  background-color: rgb(236, 28, 28);
}

/deep/ .ly-info .el-tabs__item {
  color: rgb(158, 140, 140);
}

.footer {
  height: 50px;
  position: relative;

  .num {
    margin-left: 20px;
    font-size: 14px;
    color: rgb(140, 140, 140);

    label {
      color: #ec1c1c;
    }
  }

  .cancel-btn {
    position: absolute;
    right: 20px;
  }
}

/deep/ .ly-info .el-dialog__body {
  height: 420px;
  overflow-y: auto;
}

/deep/ .ly-info .el-dialog__footer {
  text-align: left;
}
</style>
<style lang="less">
.el-popper .popper__arrow::after {
  border-bottom-color: #f5f6f6 !important;
}

.data-dialog {
  border-radius: 11px;
}

.el-dialog__header {
  padding: 0;
  border-radius: 11px;
}

.el-dialog__headerbtn .el-dialog__close {
  color: #01040a;
}

// .el-dialog__body {
//   padding: 0;
// }
</style>



// WEBPACK FOOTER //
// pages/signInfo/signList.vue